import React from "react";
import { BsBell } from "react-icons/bs";
import PersianPrice from "../Header/PersianPrice";
import { useTranslation } from "react-i18next";

const SmallMessages = ({ classes }) => {
  const { i18n } = useTranslation();
  return (
    <ul
      className={
        i18n.language === "en"
          ? classes.miniContainerLtr
          : classes.miniContainer
      }
    >
      <li className={classes.menuItem}>
        <span
          className={classes.profileTitle}
          style={{ display: "flex", marginRight: 5, marginLeft: 5 }}
        >
          <PersianPrice number={0} className={classes.profileTitle} />
          <BsBell
            fontSize={"large"}
            style={{ marginRight: 10 }}
            className={classes.icons}
          />
        </span>
      </li>
    </ul>
  );
};

export default SmallMessages;
